import queryString from 'query-string';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCharacters } from '../../actions/CharacterAction';
import { l10n } from '../../i18n/Localization';
import BackButton from '../BackButton';
import CharacterCard from './CharacterCard';

class CharactersPage extends Component {
    componentDidMount() {
        if (this.props.characters.length === 0) {
            let lastCharacterId = this.props.lastCharacterId;
            this.props.getCharacters(lastCharacterId);
        }
    }

    handleClickLoad = () => {
        let lastCharacterId = this.props.lastCharacterId;
        this.props.getCharacters(lastCharacterId);
    }

    render() {
        const { getCharactersCompleted, characters } = this.props;

        const characterCardDivs = (characters.length > 0) ? (
            characters.map(character => {
                return (
                    <div className="col-12 col-md-6 col-lg-3 mb-3" key={character.id}>
                        <CharacterCard character={character} />
                    </div>
                );
            })
        ) : (
            <div className="col-12 mb-3">
                <div className="text-center">
                    {l10n.charactersPage.noCharacter}
                </div>
            </div>
        );

        const btnLoadText = getCharactersCompleted ? l10n.charactersPage.loadMore : l10n.charactersPage.loading;

        let content = (
            <div className="container mt-3">
                <div className="d-flex justify-content-between mb-3">
                    <BackButton disabled={false} />
                    <Link className="btn btn-primary" to="/characters/new">{l10n.charactersPage.addCharacter}</Link>
                </div>
                <div className="row">
                    {characterCardDivs}
                </div>
                <div className="d-flex justify-content-center mb-3">
                    <button className="btn btn-primary" type="button" onClick={this.handleClickLoad} disabled={!getCharactersCompleted}>{btnLoadText}</button>
                </div>
            </div>
        );

        return (
            <div className="CharactersPage">
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content={l10n.charactersPage.pageTitle} />
                    <title>{l10n.charactersPage.pageTitle} - {l10n.productName}</title>
                </Helmet>
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const characters = state.characterState.getCharactersCharacters;
    const urlParams = queryString.parse(ownProps.location.search);

    let lastCharacterId;

    if (characters.length > 0) {
        let lastCharacter = characters[characters.length - 1];
        lastCharacterId = lastCharacter.id;
    } else {
        lastCharacterId = urlParams.lastCharacterId;
    }

    return {
        lastCharacterId: lastCharacterId,
        getCharactersCompleted: state.characterState.getCharactersCompleted,
        characters: characters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCharacters: (lastCharacterId) => {
            dispatch(getCharacters(lastCharacterId));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CharactersPage);
